<div class="tooltip-container" [ngClass]="{ template: template != undefined }" [ngStyle]="containerStyles">
	<div class="tooltip-content" [ngStyle]="tooltipNgStyles">
		<ng-container *ngIf="template; else stringContent">
			<ng-container *ngTemplateOutlet="template"></ng-container>
		</ng-container>
		<ng-template #stringContent>
			<div [innerHTML]="content"></div>
		</ng-template>
	</div>
</div>
